import Main from './CustomizeCookieBoxMain'

const CustomizeCookieBox = {
  Main,
}

export default CustomizeCookieBox
